/*
 * @Author: mason
 * @Date: 2022-09-27 14:49:08
 * @LastEditTime: 2024-08-30 15:29:31
 */
// import { $t } from '@/plugins/i18n';

export const LOCAL_DICT_MAP = {
  CJS_ENABLE_STATUS: ['statusDict'], // 启用状态
  CJS_IS_DELETE: ['XXX'], // 是否删除
  CJS_AUDIT_STATUS: ['auditStatus', 'reportAuditStatus', 'allAuditStatus'], // 审核状态
  CJS_OPENING_STATUS: ['isTrue'], // 开户状态
  CJS_CARRIER_SOURCE_TYPE: ['sourceTypeList', 'reportSourceTypeList'], // 数据来源
  CJS_DRIVER_ATTRIBUTE_CODE: ['driverAttribute'], // 驾驶员属性
  CJS_VEHICLE_KIND_CODE: ['xxx'], // 车种类
  CJS_VEHICLE_TYPE_CODE: ['vehicleTypeCode'], // 车型编码
  CJS_OUTAGE_STATUS: ['outageStatus'], // 停运状态
  CJS_ONLINE_STATUS: ['onLineStatus'], // 上线状态
  CJS_PROVIDE_TYPE: ['shipperType'], // 货主类型
  CJS_SETTLEMENT_TYPE: ['settlementType'], // 结算类型
  CJS_USER_STATUS: ['userStatus'], // 有效状态
  CJS_SEXS: ['sexDict', 'sexStatus'], // 性别
  CJS_AUDIT_TYPE: ['auditList'], // 审核类型
  CJS_CAR_TYPE: ['vehicleType'], // 车种类
  CJS_PAYORDER_STATUS: ['paymentOrderStatus'], // 付款单状态
  CJS_PAY_TYPE: ['paymentType'], //付款类型   PREPAYMENT: 运单预付款   FREIGHT_CHECK: 对账单付款
  CJS_ACCOUNT_TYPE: ['accountType'], // 到账方式
  CJS_TIME_TYPE: ['timeType'], // 时间类型
  CJS_REPORT_TYPE: ['reportType'], // 报备类型
  CJS_BUDGET_TYPE: ['budgetType'], // 收支类型
  CJS_USER_TYPE: ['userType'], // 用户类型
  CJS_SERVICE_TYPE: ['serviceType'], // 服务类型
  CJS_ORDER_SOURCE: ['orderSource'], // 订单来源
  CJS_ORDER_STATUS: ['orderStatus', 'filterOrderStatus'], // 订单状态
  CJS_ORDER_TIME_TYPE: ['orderTimeType'], // 预订单时间类型
  CJS_HANDLING_MODEL: ['operateType', 'handlingModel'],
  CJS_COLLECTION_CHANNEL: ['receiverChannel', 'payBehalf'], // 收款渠道
  CJS_BANK_LIST: ['receiverBank', 'bankList'], // 收款银行
  CJS_EWALLET_LIST: ['receiverEwallet', 'eWalletList'], // 收款钱包
  CJS_WAYBILL_STATUS: ['waybillStatus'], // 运单状态
  CJS_CLOSE_TYPE: ['closeType'], // 关闭类型
  CJS_PAYMENT_STATUS: ['paymentStatus'], // 承运商收款状态
  CJS_WAYBILL_SOURCE: ['waybillSource'], // 运单来源
  CJS_LOCATION_TYPE: ['locationType'], // 地址类型
  CJS_WAYBILL_TIMETYPE: ['waybillTimeType'], // 运单时间类型
  CJS_YES_OR_NO: ['yesOrNo'], // 是或否
  CJS_ORDER_QUOTESTATUS: ['quoteStatus'], // 报价状态
  CJS_PLAFORM_AUDIT: ['checkStatus'], // 平台审核
  CJS_CARRIER_CONTRACT_CODE: ['contractChannel'], // 合同渠道
  CJS_RECONCILIATION_STATUS: ['reconciliationStatus'], // 承运商对账状态
  CJS_RECONCILIATION_TIMETYPE: ['reconciliationTimeType'], // 承运商对账时间类型
  CJS_PAYORDER_AUDITSTATUS: ['paymentOrderAuditStatus'], // 付款单审核状态
  CJS_TRANSATION_STATUS: ['transactionStatus'], // 交易状态
  CJS_PAYMENT_WAY: ['paymentWay'], // 支付方式
  CJS_FILE_STATUS: ['fileStatus'],
  CJS_ORDER_TYPE: ['budgetOrderType'],
  CJS_MOBILE_CODE: ['smsMobileCode'], // 手机区号
  CJS_SMS_SOURCE: ['smsSource'], // 短信来源
  CJS_SMS_SERVICE: ['smsService'], // 短信服务商
  CJS_SMS_STATE: ['smsStatus'], // 状态
  CJS_SMS_TYPE: ['smsType'], // 短信类型
  CJS_RDBC_LEVE: ['rdbcDict'], // 权限级别
  CJS_MENU_TYPE: ['menuTypeDict'], // 菜单类型
  CJS_FEE_DEDUCT_TYPE: ['feeDeductType'],
  CJS_CAR_ATTRIBUTE_CODE: ['vehicleAttribute'], // 车辆属性
  CJS_WITHHOLDING_TAX_RATE: ['withholdingTaxRate', 'taxDeductRateList'], // 预扣税税率
  CJS_RECONCILIATION_STATUS_SHIPPER: ['shipperReconciliationStatus'], // 货主对账单对账状态
  CJS_PAYMENT_STATUS_SHIPPER: ['shipperPaymentStatus'], // 货主对账单收款状态
  CJS_IS_CANCELLATION: ['isDelete'], // 货主对账单是否作废
  CJS_COUSTOMER_PRICE: ['queryPricePermissionList'] // 用户查看价格权
};

// 获取空白的key值数组,减少重复定义
const _emptyData = Object.values(LOCAL_DICT_MAP).reduce((data, item) => {
  if (typeof item === 'string') {
    data[item] = [];
  } else if (Array.isArray(item)) {
    // eslint-disable-next-line no-return-assign
    item.forEach(key => (data[key] = []));
  }
  return data;
}, {});

export const LOCAL_EMPTY_DATA = {
  ..._emptyData
  // menuTypeDict: [
  //   {
  //     value: 1,
  //     label: $t('目录')
  //   },
  //   {
  //     value: 2,
  //     label: $t('菜单')
  //   },
  //   {
  //     value: 3,
  //     label: $t('按钮')
  //   }
  // ]
  // rdbcDict: [
  //   {
  //     value: 1,
  //     label: $t('管理员')
  //   },
  //   {
  //     value: 2,
  //     label: $t('普通用户')
  //   }
  // ]
};

// 远程数据key值跟本地原有的key值不一致,需要做转义,value值以本地的为主,例如本地的是 1 ,远程的对应中文名的key值是2,则要把 2 转换为1,
// 格式为 =>  远程value : 本地的value;
export const LOCAL_TRANSFOR_DICT = {};

// 远程数据多于本地,需要做过滤操作, 可以执行下test.js去手动校验一遍
export const LOCAL_FILTER_DICT = {
  // 'idleVehicleAttributeList': (item) => {
  //   return item.value !== 4
  // }
  reportSourceTypeList: item => {
    return item.value !== 'CARRIER-PC';
  },
  filterOrderStatus: item => {
    return (
      item.value !== 'inquiring' &&
      item.value !== 'awaiting_quotation' &&
      item.value !== 'quoted' &&
      item.value !== 'quote_confirm'
    );
  },
  auditStatus: item => {
    return item.value !== 4;
  },
  reportAuditStatus: item => {
    return item.value !== 4;
  }
};

// 需要将数据字典类型 转为字符串
export const LOCAL_STRING_DICT = [
  'vehicleType',
  'vehicleTypeCode',
  'receiverChannel',
  'contractChannel'
];

// 特殊数据字典如： '01', '02'  不做转number处理，避免改动原数据结构
export const SPEC_DICT = [];
